import { FileDownloadIcon, TablePager } from '@fukuri-admins/ui/common';
import { ActionButton } from '~/components/common/ActionButton';
import { ContentsHeader } from '~/components/common/ContentsHeader';
import { ServiceReportTableContent } from '~/components/ServiceReport/ServiceReportTableContent';
import Shimmer from '~/components/Shimmer';
import styles from '../styles.module.scss';

type ServiceReportTableContentProps = React.ComponentProps<typeof ServiceReportTableContent>;
type Props = {
  loading: boolean;
  filteredServiceApplications: ServiceReportTableContentProps['rows'];
  pagerProps: React.ComponentProps<typeof TablePager>;
  handleOutputCsv: () => Promise<void>;
  handleHeaderSort: ServiceReportTableContentProps['onSort'];
};

export const ServiceReportPresentation: React.FC<Props> = ({
  loading,
  filteredServiceApplications,
  pagerProps,
  handleOutputCsv,
  handleHeaderSort,
}) => {
  return (
    <div className={styles.Root}>
      <div className={styles.container}>
        <ContentsHeader
          title='サービス利用履歴'
          description='以下より、サービス利用履歴を確認できます。'
          actions={
            <ActionButton
              content='CSV出力'
              type='darkFill'
              icon={<FileDownloadIcon />}
              iconPosition='left'
              action={handleOutputCsv}
            />
          }
        />
        {loading ? (
          <Shimmer />
        ) : (
          <div className={styles.Root__Table}>
            <div className={styles.tableWrapper}>
              <ServiceReportTableContent
                rows={filteredServiceApplications}
                onSort={handleHeaderSort}
              />
            </div>
            <TablePager {...pagerProps} />
          </div>
        )}
      </div>
    </div>
  );
};
